import * as CookieConsent from "vanilla-cookieconsent";
import '@orestbida/iframemanager';
import Maps from "./Maps";

export default class CookieBar {
    constructor() {
        // obtain plugin
        this.settings = cookiesettings;
        this.blocks = this.settings.blocks.map((item, key) => {
            return {
                title: item.title,
                description: item.description,
                linkedCategory: item.toggle_value,
            };
        });

        this.categories = {};
        this.settings.blocks.filter(item => item.toggle_value).map((item, key) => {
            let services = {};
            item.services.map((item) => {
                services[`${item.name}`] = {
                    label: item.label,
                    onAccept: () => this.im.acceptService(item.name),
                    onReject: () => this.im.rejectService(item.name)
                }
            })
            this.categories[`${item.toggle_value}`] = {
                enabled: item.toggle_enabled,
                readonly: item.toggle_readonly,
                services: services
            }
        });

        this.im = iframemanager();
        this.im.run({
            currLang: 'de',
            services: {
                youtube: {
                    embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
                    thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
                    iframe: {
                        allow: 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
                    },
                    languages: {
                        en: {
                            notice: 'Dieser Inhalt wird von Youtube zur Verfügung gestellt. Durch anzeigen des Videos akzeptieren Sie die <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">Geschäftsbedingungen</a> von youtube.com.',
                            loadBtn: 'Ok, lade das Video',
                            loadAllBtn: "Videos von Youtube immer laden"
                        }
                    }
                }
            },
            onChange: ({changedServices, eventSource}) => {
                if (eventSource.type === 'click') {
                    const servicesToAccept = [
                        ...CookieConsent.getUserPreferences().acceptedServices['youtube'],
                        ...changedServices
                    ];
                    CookieConsent.acceptService(servicesToAccept, 'youtube');
                }
            },
        });

        // run plugin with your configuration
        CookieConsent.run({
            // categories: {
            //     necessary: {
            //         enabled: true,  // this category is enabled by default
            //         readOnly: true  // this category cannot be disabled
            //     },
            //     analytics: {},
            //     youtube: {
            //         services: {
            //             youtube: {
            //                 label: 'Youtube Videos',
            //                 onAccept: () => this.im.acceptService('youtube'),
            //                 onReject: () => this.im.rejectService('youtube')
            //             }
            //         }
            //     }
            // },
            categories: this.categories,
            current_lang: 'de',
            autoclear_cookies: true,                   // default: false
            page_scripts: true,                        // default: false
            cookie_expiration: 1,                 // default: 182 (days)
            guiOptions: {
                consentModal: {
                    layout: 'cloud',
                    position: 'bottom right',
                    flipButtons: false,
                    equalWeightButtons: false
                },
                preferencesModal: {
                    layout: 'box',
                    // position: 'right',
                    flipButtons: false,
                    equalWeightButtons: false
                }
            },
            language: {
                default: 'de',
                translations: {
                    de: {
                        consentModal: {
                            title: this.settings.title,
                            description: this.settings.description,
                            acceptAllBtn: this.settings.accept_all_label,
                            acceptNecessaryBtn: this.settings.deny_all_label,
                            showPreferencesBtn: 'Cookie Einstellungen',
                        },
                        preferencesModal: {
                            title: this.settings.settings_title,
                            savePreferencesBtn: this.settings.save_label,
                            acceptAllBtn: this.settings.accept_all_label,
                            acceptNecessaryBtn: this.settings.deny_all_label,
                            closeIconLabel: this.settings.close_label,
                            sections: this.blocks
                        }
                    }
                }
            },
            onChange: ({cookie, changedCategories, changedServices}) => {
                const mapDiv = document.getElementById('map');
                if (changedCategories.includes('maps') && !!mapDiv) {
                    new Maps();
                }
            }
        });
    }
}
